/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {deleteTimecard} from '../api'

export const useMutationDeleteTimecard = createReactQueryMutationHook('deleteTimecard', deleteTimecard)
